// useCellReferences.ts
import { useMemo } from 'react';

export interface MappingReference {
  document_reference: string;
  sheet_name: string;
  cell_references?: { ref: string }[];
}

export const useCellReferences = (
  mappingReferences: MappingReference[] | undefined, 
  sourceMap: Map<number, number>
): string => useMemo(() => {
  if (!mappingReferences || mappingReferences.length === 0) {
    return 'Mapped from source document';
  }

  return mappingReferences
    .map((ref: MappingReference) => {
      const cellRefs = ref.cell_references?.map(cr => cr.ref).join(', ') || 'N/A';
      const documentId = Number(ref.document_reference);
      const sourceNumber = Number.isNaN(documentId) ? undefined : sourceMap.get(documentId);
      const sourceLabel = sourceNumber ? `Source ${sourceNumber}` : `Source ${ref.document_reference}`;
      return `${sourceLabel} - Sheet: ${ref.sheet_name} - Cells: ${cellRefs}`;
    })
    .join(' | '); // Using pipe for better horizontal scanning in a status bar
}, [mappingReferences, sourceMap]);
